export const hasMemberCs = (types) => {
  return types.includes('Membre du Conseil Syndical')
}
